import { datadogRum } from "@datadog/browser-rum";
import { buildClockworkWebPath } from "lib/resource-finder";

export type TrackEventJSON = {
  event_type: string;
  actor_id: string;
  company_id: string;
  member_id?: string;
  office_id?: string;
  metadata?: { [key: string]: unknown };
};

export const sendTrackEvent = async (eventData: TrackEventJSON) => {
  const trackEventUrl = buildClockworkWebPath(
    "/api/v3/market_expansion/track_event"
  );

  // Get CSRF token from meta tag (set by Rails)
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

  await fetch(trackEventUrl, {
    method: "POST",
    cache: "no-cache",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken || "",
    },
    body: JSON.stringify(eventData),
  })
    .then((response) => {
      if (!response.ok) {
        datadogRum.addError(
          new Error(
            `Failed to send track event ${eventData.event_type} with status: ${response.status}`
          )
        );
      }
    })
    .catch((error) => {
      datadogRum.addError(error);
    });
};
